export enum CMS_KEYS {
  USER_MANUAL = 'userManual',
}
